import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppSandbox } from '../app.sandbox';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private appSandbox: AppSandbox) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('token');
        let request = req;
        if (token) {
            const headerValue = 'Bearer ' + token;
            request = req.clone({
                headers: req.headers.set('X-Mysite-Authorization', headerValue)
            });
        }

        return next.handle(request)
            .pipe(tap(() => {}, (err) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        return;
                    }

                    this.appSandbox.logout();
                }
            }));
    }
}
